export type Task = () => void
export interface ConcurrentQueueConfig {
  concurrency: number
}

export type TaskId = any

export class ConcurrentQueue {
  private concurrency: number = 1
  private running: number = 0
  private taskQueue: Task[] = []
  constructor(config: ConcurrentQueueConfig) {
    if (config && config.concurrency) {
      this.concurrency = config.concurrency
    }
  }

  private async runTask(task: Task) {
    this.running++
    try {
      await task()
    } finally {
      this.running--
      if (this.taskQueue.length) {
        const nextTask = this.taskQueue.shift()
        if (nextTask) {
          this.runTask(nextTask)
        }
      }
    }
  }

  private enqueueTask(task: Task) {
    this.taskQueue.push(task)
  }

  public push(task: Task) {
    if (typeof task !== 'function') {
      throw new TypeError(
        `Task ${task} is not a function. It is of type: ${typeof task}`
      )
    }
    if (this.running < this.concurrency) {
      this.runTask(task)
    } else this.enqueueTask(task)
  }
}

export function useConcurrentQueue() {
  function createQueue(config: ConcurrentQueueConfig) {
    return new ConcurrentQueue(config)
  }
  return { createQueue }
}
